import { CSSProperties } from 'react';
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const DEFAULT_TOAST_DURATION_MS = 4000;

const Toaster = ({
  theme = 'light',
  duration = DEFAULT_TOAST_DURATION_MS,
  ...props
}: ToasterProps) => {
  return (
    <Sonner
      theme={theme}
      duration={duration}
      className="toaster group"
      closeButton
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
          '--toast-duration': `${duration}ms`,
        } as CSSProperties
      }
      {...props}
      position="bottom-right"
    />
  );
};

export { Toaster };
